{
  "version": 1,
  "asset_id": "078ec85d-463f-4ae5-a064-ee867f9dd0e5",
  "project_id": "affbb9b7-8892-4de7-a6a3-a24f8c559459",
  "url": "/__l5e/assets-v1/078ec85d-463f-4ae5-a064-ee867f9dd0e5/pavimento-pietra-ciottoli-mosaico-lombardia.webp",
  "r2_key": "a/v1/affbb9b7-8892-4de7-a6a3-a24f8c559459/078ec85d-463f-4ae5-a064-ee867f9dd0e5/pavimento-pietra-ciottoli-mosaico-lombardia.webp",
  "original_filename": "pavimento-pietra-ciottoli-mosaico-lombardia.webp",
  "size": 444122,
  "content_type": "image/webp",
  "created_at": "2026-09-02T15:20:58Z"
}
